import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileHeaderBar = _resolveComponent("MobileHeaderBar")!

  return (_openBlock(), _createBlock(_component_MobileHeaderBar, _normalizeProps(_guardReactiveProps(_ctx.headerProps)), null, 16))
}